export default {
  getDepartamentos: state => state.departamentos,
  getOperadores: state => state.operadores,
  getFilas: state => state.filas,
  getPausas: state => state.pausas,
};
